"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_virtualized_1 = require("@enykeev/react-virtualized");
const react_1 = __importDefault(require("react"));
const StyledOption_1 = __importDefault(require("../StyledOption"));
const FlagImage_1 = __importDefault(require("../Value/FlagImage"));
const cache_1 = __importDefault(require("./cache"));
const countries_1 = __importDefault(require("./countries"));
const CountryWrapper_1 = __importDefault(require("./CountryWrapper"));
const StyledPhoneCode_1 = __importDefault(require("./StyledPhoneCode"));
const Row = ({ index, parent, selectedAlphaCode2, style, onSelect, flagsHost }) => {
    const country = react_1.default.useMemo(() => countries_1.default[index], [index]);
    const isSelected = react_1.default.useMemo(() => country.alphaCode2 === selectedAlphaCode2, [country.alphaCode2, selectedAlphaCode2]);
    const handleOnSelect = react_1.default.useCallback(() => {
        if (onSelect) {
            onSelect(country);
        }
    }, [onSelect, country]);
    return ((0, jsx_runtime_1.jsx)(react_virtualized_1.CellMeasurer, { cache: cache_1.default, parent: parent, columnIndex: 0, rowIndex: index, style: style, children: ({ registerChild }) => ((0, jsx_runtime_1.jsx)("div", { ref: (element) => {
                if (element && registerChild) {
                    registerChild(element);
                }
            }, onClick: handleOnSelect, style: style, children: (0, jsx_runtime_1.jsxs)(StyledOption_1.default, { value: country, selectedIcon: null, isSelected: isSelected, children: [(0, jsx_runtime_1.jsx)(FlagImage_1.default, { src: `${flagsHost}/${country.flag}`, height: 22, width: 22, alt: `${country.name} flag` }), (0, jsx_runtime_1.jsx)(CountryWrapper_1.default, { children: country.name }), ' ', (0, jsx_runtime_1.jsx)(StyledPhoneCode_1.default, { children: country.phoneCode })] }, index) })) }));
};
exports.default = Row;
//# sourceMappingURL=Row.js.map